/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementImportItemResponse } from './CarpsaleManagementImportItemResponse';

export type CarpsaleManagementImportItemResponseApiRespoonse = {
    data?: CarpsaleManagementImportItemResponse;
    status?: CarpsaleManagementImportItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementImportItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

